import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.from";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.replace";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/createSuper";
import _wrapNativeSuper from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
import Vue from 'vue';
import { img2base64, base642ObjectUrl, blobToObjUrl, getImgUrl, isInlineData, IOS_MAX_BASE64, getSupportBase64CrossStatus } from './helper';

var ImageError = /*#__PURE__*/function (_Error) {
  _inherits(ImageError, _Error);

  var _super = _createSuper(ImageError);

  function ImageError() {
    var _this;

    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        url = _ref.url,
        message = _ref.message;

    _classCallCheck(this, ImageError);

    _this = _super.call(this, message);
    _this.url = url;
    _this.message = message;
    return _this;
  }

  return ImageError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var ImageResult = function ImageResult() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      base64 = _ref2.base64,
      _ref2$tryCount = _ref2.tryCount,
      tryCount = _ref2$tryCount === void 0 ? 0 : _ref2$tryCount,
      error = _ref2.error,
      _ref2$cost = _ref2.cost,
      cost = _ref2$cost === void 0 ? 0 : _ref2$cost;

  _classCallCheck(this, ImageResult);

  this.base64 = base64;
  this.code = base64 ? 0 : -1;
  this.tryCount = tryCount;
  this.error = error;
  this.cost = cost;
};

function transformImage(url) {
  var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref3$tryCount = _ref3.tryCount,
      tryCount = _ref3$tryCount === void 0 ? 2 : _ref3$tryCount,
      _ref3$quality = _ref3.quality,
      quality = _ref3$quality === void 0 ? 1 : _ref3$quality,
      _ref3$contentType = _ref3.contentType,
      contentType = _ref3$contentType === void 0 ? 'image/png' : _ref3$contentType;

  return new Promise( /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(resolve) {
      var startTime, oldVal, message, isSupport, objUrl, base64, blob, res;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              startTime = Date.now();
              oldVal = tryCount;
              message = null;
              _context.next = 5;
              return getSupportBase64CrossStatus();

            case 5:
              isSupport = _context.sent;

              if (!isInlineData(url)) {
                _context.next = 17;
                break;
              }

              if (!isSupport) {
                _context.next = 11;
                break;
              }

              _context.t0 = url;
              _context.next = 14;
              break;

            case 11:
              _context.next = 13;
              return base642ObjectUrl(url);

            case 13:
              _context.t0 = _context.sent;

            case 14:
              objUrl = _context.t0;
              resolve(new ImageResult({
                base64: objUrl,
                tryCount: 0
              }));
              return _context.abrupt("return");

            case 17:
              if (!tryCount) {
                _context.next = 65;
                break;
              }

              _context.prev = 18;

              if (!isSupport) {
                _context.next = 39;
                break;
              }

              _context.next = 22;
              return img2base64(url, {
                contentType: contentType,
                quality: quality
              });

            case 22:
              base64 = _context.sent;
              _context.t1 = resolve;
              _context.t2 = ImageResult;

              if (!(base64.length > IOS_MAX_BASE64)) {
                _context.next = 31;
                break;
              }

              _context.next = 28;
              return base642ObjectUrl(base64);

            case 28:
              _context.t3 = _context.sent;
              _context.next = 32;
              break;

            case 31:
              _context.t3 = base64;

            case 32:
              _context.t4 = _context.t3;
              _context.t5 = oldVal - tryCount;
              _context.t6 = Date.now() - startTime;
              _context.t7 = {
                base64: _context.t4,
                tryCount: _context.t5,
                cost: _context.t6
              };
              _context.t8 = new _context.t2(_context.t7);
              (0, _context.t1)(_context.t8);
              return _context.abrupt("return");

            case 39:
              _context.next = 41;
              return img2base64(url, {
                result: 'blob',
                contentType: contentType,
                quality: quality
              });

            case 41:
              blob = _context.sent;
              _context.next = 44;
              return blobToObjUrl(blob);

            case 44:
              res = _context.sent;
              _context.t9 = res;

              if (_context.t9) {
                _context.next = 50;
                break;
              }

              _context.next = 49;
              return img2base64(url, {
                contentType: contentType,
                quality: quality
              });

            case 49:
              _context.t9 = _context.sent;

            case 50:
              res = _context.t9;
              resolve(new ImageResult({
                base64: res,
                tryCount: oldVal - tryCount,
                cost: Date.now() - startTime
              }));
              _context.next = 63;
              break;

            case 54:
              _context.prev = 54;
              _context.t10 = _context["catch"](18);
              tryCount--;
              message = "".concat(url, " transformImage error, want retry count: ").concat(oldVal, " current\uFF1A").concat(tryCount, ", contentType:").concat(contentType, ", quality:").concat(quality);

              if (!(tryCount === 0)) {
                _context.next = 61;
                break;
              }

              resolve(new ImageResult({
                base64: null,
                tryCount: oldVal - tryCount,
                error: new ImageError({
                  url: url,
                  message: message
                }),
                cost: Date.now() - startTime
              }));
              return _context.abrupt("return");

            case 61:
              url = getImgUrl(url);
              console.warn(message, _context.t10);

            case 63:
              _context.next = 17;
              break;

            case 65:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[18, 54]]);
    }));

    return function (_x) {
      return _ref4.apply(this, arguments);
    };
  }());
}

var timer = null;
export default {
  bind: function bind(el, binding, vnode, oldVnode, source) {
    if (binding.value) {
      var data = vnode.data;
      Vue.nextTick( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var s1, isChangeFlag, isErrorFlag, imgs, temp, item, replaceFlag, i, res, time;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                clearTimeout(timer); // timer = setTimeout(async ()=>{

                s1 = Date.now();
                isChangeFlag = false;
                isErrorFlag = null;
                imgs = el.querySelectorAll('img') || [];
                temp = null;
                item = null;
                replaceFlag = null;
                i = 0;

              case 9:
                if (!(i < imgs.length)) {
                  _context2.next = 27;
                  break;
                }

                item = imgs[i];
                temp = item.src;
                replaceFlag = item.dataset['replace'];

                if (!replaceFlag) {
                  _context2.next = 15;
                  break;
                }

                return _context2.abrupt("continue", 24);

              case 15:
                item.setAttribute('crossOrigin', 'Anonymous');
                item.setAttribute('data-replace', 1);
                _context2.next = 19;
                return transformImage(temp, {
                  tryCount: data && data.attrs && +data.attrs.tryCount || 2,
                  quality: +item.dataset.zip || 1,
                  contentType: item.dataset.contentType || 'image/png'
                });

              case 19:
                res = _context2.sent;
                if (res.code !== 0) isErrorFlag = res.error;
                item.src = res.base64;
                data && data.on && data.on.report && data.on.report(res);
                isChangeFlag = isChangeFlag || item.src !== temp;

              case 24:
                i++;
                _context2.next = 9;
                break;

              case 27:
                isErrorFlag && data && data.on && data.on.error && data.on.error(isErrorFlag, Date.now() - s1); // 这里处理的是里面的图片都是base64的情况

                if (!isChangeFlag && Array.from(imgs).filter(function (img) {
                  return isInlineData(img.src);
                }).length === imgs.length) {
                  isChangeFlag = true;
                } // 没有图片的情况


                if (imgs.length === 0) {
                  isChangeFlag = true;
                } // 触发imgLoad方法


                if (isChangeFlag && !isErrorFlag) {
                  time = Date.now() - s1;
                  isChangeFlag && data && data.on && data.on.load && data.on.load(time);
                  console.log('replace to base64 cost:' + time);
                } // }, 100)


              case 31:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })));
    }
  },
  inserted: function inserted(el, binding) {},
  update: function update(el, binding, vnode, oldVnode) {
    if (binding.oldValue !== binding.value) {
      binding.def.bind(el, binding, vnode, oldVnode, 'update');
    }
  },
  componentUpdated: function componentUpdated(el, binding, vnode, oldVnode) {
    if (binding.oldValue !== binding.value) {
      binding.def.bind(el, binding, vnode, oldVnode, 'componentUpdated');
    }
  },
  unbind: function unbind(el, binding) {}
};